import { useState } from 'react';
import { apiFetch } from '../../../auth/apiFetch';

const apiBaseUrl = process.env.REACT_APP_BOOKCARD_URL || process.env.REACT_APP_API_URL || window.location.origin;

export function useBookcard() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [lastGenerated, setLastGenerated] = useState(null);

  const generateBookcard = async (ean, bioOverrides) => {
    setLoading(true);
    setError(null);
    setLastGenerated(null);
    try {
      const hasOverrides = bioOverrides && Object.keys(bioOverrides).length > 0;
      const res = hasOverrides
        ? await apiFetch(`${apiBaseUrl}/api/bookcard/${ean}/preview`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(bioOverrides),
          })
        : await apiFetch(`${apiBaseUrl}/api/bookcard/${ean}`);
      if (res.status === 404) throw new Error(`EAN ${ean} not found in database`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${ean}-bookcard.pdf`;
      a.click();
      URL.revokeObjectURL(url);
      setLastGenerated(ean);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  return { generateBookcard, loading, error, lastGenerated };
}
